module.exports = __webpack_public_path__ + "static/media/tickets-ganado.f864d0b8.png";